import { useEffect } from "react";

function useClearCaches() {
  useEffect(() => {
    const clearCaches = async () => {
      if ("caches" in window) {
        try {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(name => caches.delete(name)));
          console.log("✓ HTML/CSS/JS Cache cleared");
        } catch (err) {
          console.error("Failed to clear caches:", err);
        }
      }
    };

    clearCaches();
  }, []);
}

export default useClearCaches;
